import React from "react";
import BackTo from "../Components/LinkBackTo/LinkBackTo";

const PromotionsAdmin = () => {
  return (
    <div>
    <div>
      <BackTo move="/PromotionsList" nameback="PROMOTIONS"/>
    </div>
    </div>)
};

export default PromotionsAdmin;
